<template>
  <Transition name="fade" mode="out-in">
    <section class="navigation">
      <div class="navigation-title">
        <span>{{ title }}</span>
        <NuxtLink :to="prefix" class="navigation-title__link" exactActiveClass="bg-gray-50">
          <Icon name="tabler:home" />
        </NuxtLink>
      </div>
      <nav class="navigation-content">
        <template v-for="{ type, ...item } in navigation">
          <div v-if="type === 'title'" class="navigation-content__title">{{ item.title }}</div>
          <NuxtLink
            v-if="type === 'link'"
            :to="prefix + item.link"
            :class="{ active: route.fullPath.startsWith(prefix + item.link), 'pointer-events-none': item.disabled }"
            class="navigation-content__link"
          >
            <Icon class="navigation-content__link-icon" :name="item.icon" />
            <span class="navigation-content__link-title">{{ item.title }}</span>
            <span
              v-if="item.badge"
              class="navigation-content__link-badge"
              :class="{ [`navigation-content__link-badge--${item?.status}`]: item?.status }"
            >
              {{ item.badge }}
            </span>
          </NuxtLink>
        </template>
      </nav>
    </section>
  </Transition>
</template>

<script setup lang="ts">
  const route = useRoute()

  const props = defineProps<{
    title: string
    prefix: string
    navigation: Array<{
      type: string
      title?: string
      link?: string
      icon?: string
      badge?: string
      status?: string
      disabled?: boolean
    }>
  }>()
</script>

<style lang="scss" scoped>
  .navigation {
    @apply flex flex-col h-full overflow-hidden transition-all duration-200 flex-none;
    width: calc(100% - var(--sidebar-menu-width));

    @screen md {
      width: var(--sidebar-navigation-width);
      min-width: var(--sidebar-navigation-min-width);
    }

    &-title {
      @apply font-display tracking-wide flex-none flex items-center h-14 px-5 text-[15px] text-gray-700 font-semibold;

      a {
        @apply flex items-center justify-center ml-auto size-8 -mr-2 rounded-md transition-all duration-200 text-gray-400 hover:bg-gray-40;
      }
    }
    &-content {
      @apply flex flex-col px-3 gap-1.5 overflow-auto pb-3;

      &__title {
        @apply flex-none px-2.5 mt-4 mb-1 text-gray-200 text-[13px] leading-none;
      }
      &__link {
        @apply flex-none flex items-center gap-2 rounded-lg text-gray-600 px-2 h-9 transition-all duration-200 hover:bg-gray-40;

        &-icon {
          @apply text-gray-300 size-5 transition-all duration-200;
        }
        &-title {
          @apply transition-all duration-200 font-[450];
        }
        &-badge {
          @apply bg-black/5 px-1.5 rounded-md border border-black/5 text-[10px] font-semibold leading-none py-[5px] text-black/80 uppercase ml-auto;

          &--success {
            @apply bg-green-50 border-green-100 text-green-700;
          }
        }
        &.active {
          @apply bg-gray-50/50 font-medium;
        }
        &.active & {
          &-icon {
            @apply text-gray-500;
          }
        }
      }
    }
  }
</style>
